// seoData.js
const seoData = {
  professional: {
    careerOpportunities: {
      title: 'IFERP Career Opportunities | Elevate Your Professional Growth',
      description:
        'Discover career opportunities and professional growth resources with IFERP. Connect with experts, enhance your skills, and access research-focused job prospects.',
      canonical: 'https://dashboard.iferp.in/professional/career-support/15/15',
    },
    careerSupport: {
      title: 'IFERP Career Support | Advance Your Research & Academic Career',
      description: `Explore IFERP's career support services to enhance your academic and research journey. Get mentorship, publication assistance, and networking opportunities.`,
      canonical: 'https://dashboard.iferp.in/professional/career-support/6/6',
    },
    chapters: {
      title: 'IFERP Professional Chapters | Connect with Research Communities',
      description:
        'Explore IFERP Professional Chapters and join a network of researchers, scholars, and industry experts in your field. Engage in knowledge-sharing and collaboration.',
      canonical:
        'https://dashboard.iferp.in/professional/chapters-groups/chapters',
    },
    chaptersSigGroups: {
      title: 'IFERP Special Interest Groups | Collaborate on Niche Research',
      description:
        'Join IFERP Special Interest Groups (SIGs) to collaborate with professionals on niche research topics, industry trends, and academic advancements.',
      canonical:
        'https://dashboard.iferp.in/professional/chapters-groups/sig-groups',
    },
    committeeMember: {
      title: 'Apply for IFERP Conference Committee | Become an Academic Leader',
      description:
        'Apply to be a committee member for IFERP conferences and contribute to global academic and research discussions in your field.',
      canonical:
        'https://dashboard.iferp.in/professional/conferences-and-events/apply-for-committee-member',
    },
    dashboard: {
      title: 'IFERP Professional Dashboard | Manage Research & Conferences',
      description:
        'Access your IFERP Professional Dashboard to manage conference participation, research collaborations, academic publications, and membership benefits.',
      canonical: 'https://dashboard.iferp.in/professional/dashboard',
    },
    digitalLibrary: {
      title: 'IFERP Digital Library | Access Research Papers & Journals',
      description:
        'Browse the IFERP Digital Library for the latest research papers, Scopus-indexed journals, and academic publications in various fields.',
      canonical: 'https://dashboard.iferp.in/professional/digital-library',
    },
    scopusIndexedJournals: {
      title: 'IFERP Scopus-Indexed Journals | Publish High-Impact Research',
      description:
        'Submit your research papers to Scopus-indexed journals through IFERP and enhance your academic visibility and impact.',
      canonical:
        'https://dashboard.iferp.in/professional/publications/scopus-indexed-journals',
    },
    upgradeMembership: {
      title: 'Upgrade IFERP Membership | Unlock Exclusive Research Benefits',
      description:
        'Upgrade your IFERP membership to gain access to premium research resources, exclusive events, and global networking opportunities.',
      canonical: 'https://dashboard.iferp.in/professional/upgrade',
    },
    memberRegister: {
      title: 'IFERP Professional Membership | Registration',
      description:
        'Sign up for IFERP Professional Membership and gain exclusive access to research publications, conferences, and career growth opportunities.',
      canonical: 'https://dashboard.iferp.in/professional/member/register',
    },
  },
  student: {
    chapters: {
      title: 'IFERP Student Chapters | Join Academic Research Communities',
      description:
        'Become a part of IFERP Student Chapters to engage in research, attend conferences, and network with peers and mentors globally.',
      canonical: 'https://dashboard.iferp.in/student/chapters-groups/chapters',
    },
    conference: {
      title: 'IFERP Student Conferences | Explore Research & Innovation Events',
      description:
        'Browse upcoming IFERP conferences and events. Present your research, connect with scholars, and enhance your academic career.',
      canonical:
        'https://dashboard.iferp.in/student/conferences-and-events/event-list/conference',
    },
    memberRegister: {
      title: 'IFERP Student Membership | Registration',
      description:
        'Join IFERP as a student member and access mentorship, research guidance, academic conferences, and scholarship programs.',
      canonical: 'https://dashboard.iferp.in/student/member/register',
    },
  },
  corporate: {
    memberRegister: {
      title: 'IFERP Corporate Membership | Registration',
      description:
        'Register for IFERP Corporate Membership and collaborate with top researchers, institutions, and industry leaders to drive innovation and research excellence.',
      canonical: 'https://dashboard.iferp.in/corporate/member/register',
    },
  },
  institutional: {
    memberRegister: {
      title: 'IFERP Institutional Membership | Registration',
      description:
        'Enroll your institution as an IFERP member to access global research collaborations, academic conferences, and publication support.',
      canonical: 'https://dashboard.iferp.in/institutional/member/register',
    },
  },
  common: {
    dashboard: {
      title: 'IFERP - Dashboard',
      description:
        'Access the IFERP Dashboard to manage your membership, register for events, track research submissions, and connect with the global academic community.',
      canonical: 'https://dashboard.iferp.in/',
    },
    memberLogin: {
      title: 'IFERP Membership | Login',
      description:
        'Log in to your IFERP account to manage membership benefits, submit research, register for events, and explore academic opportunities.',
      canonical: 'https://dashboard.iferp.in/member/login',
    },
    memberRegister: {
      title: 'IFERP Membership | Registration',
      description:
        'Register as an IFERP member to connect with researchers, attend conferences, publish papers, and advance your academic career.',
      canonical: 'https://dashboard.iferp.in/member/register',
    },
  },
};

export default seoData;
